import type { ComponentProps } from 'react';

import type { Button } from '../storyblocks-design-system/components/atoms/Button/Button';

export const BUTTON_VARIANTS: Array<
  NonNullable<ComponentProps<typeof Button>['variant']>
> = [
  'primary',
  'secondary',
  'outlined-dark',
  'outlined-light',
  'text',
  'alternate',
];

export const REL_VALUES: Array<
  NonNullable<ComponentProps<typeof Button>['rel']>
> = [
  'alternate',
  'author',
  'bookmark',
  'external',
  'help',
  'license',
  'next',
  'prev',
  'search',
  'tag',
  'nofollow',
  'noopener',
  'noreferrer',
  'dns-prefetch',
  'preconnect',
  'preload',
  'prefetch',
  'prerender',
  'archives',
  'stylesheet',
  'pingback',
];
